import React from "react";
import { Container, Grid } from "@material-ui/core";
import { HeaderHLPure } from "../../pures";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout"
import "./user-administration-new.css";
import UserAdministrationList from "./user-administration-list";
import UserAdministrationUserData from "./user-administration-user-data";
import UserAdministrationUserRoles from "./user-administration-user-roles";
import { useState } from "react";

const OfferView = (props) => {
  const [selected, setSelected] = React.useState(0)
  const [isEditing, setIsEditing] = useState(false)

  const {
    t,
    selectedUser,
    setSelectedUser
  } = props

  const handleSelect = (e) => {
    setSelected(e.selected);
  };

  const handleBack = () => {
    setSelectedUser({})
    setSelected(0);
  }

  return (
    <Container className="view-container userAdministrationView">
      <Grid container spacing={2}>
        <Grid item xs={12} className='header-inbox'>
          <HeaderHLPure title={t("title")} />
        </Grid>

        {
          // Main grid table
          !selectedUser?.name ?
            <UserAdministrationList setData={setSelectedUser} {...props} />
            :
            <>
              <Grid item xs={12}>
                <TabStrip
                  selected={selected}
                  onSelect={handleSelect}
                  tabPosition={'left'}
                >
                  <TabStripTab title={t("generalData")} disabled={isEditing} >
                    <UserAdministrationUserData t={t} selectedUser={selectedUser} handleBack={handleBack} />
                  </TabStripTab>
                  <TabStripTab title={t("roles")} >
                    <UserAdministrationUserRoles
                      t={t}
                      roles={props.roles}
                      selectedUser={selectedUser}
                      handleBack={handleBack}
                      isEditing={isEditing}
                      setIsEditing={setIsEditing}
                      updateUserRoles={props.updateUserRoles}
                    />
                  </TabStripTab>
                </TabStrip>
              </Grid>
            </>
        }
      </Grid>
    </Container>
  );
}

export { OfferView as default };